import { render, staticRenderFns } from "./auth-header.html?vue&type=template&id=1f5ec5c1&scoped=true&"
import script from "./auth-header.js?vue&type=script&lang=js&"
export * from "./auth-header.js?vue&type=script&lang=js&"
import style0 from "./auth-header.scss?vue&type=style&index=0&id=1f5ec5c1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5ec5c1",
  null
  
)

export default component.exports